import { useCallback } from 'react'
import styled from 'styled-components'

import {
  ClickableList,
  ClickableListItem,
  RightActionButton
} from '@cdab/scania/qpr/components/atoms'
import { useCssVariableBreakpoint } from '@cdab/scania/qpr/hooks'
import type { SystemMessage } from '@cdab/scania/qpr/schema'
import { getFirstLineFromHtmlText } from '@cdab/utils'
import { TdsBlock, TdsIcon } from '@scania/tegel-react'
import cx from 'classnames'
import type { SystemMessagesWidgetProps } from './system-messages-widget.types'

const StyledBlock = styled(TdsBlock)`
  display: grid;
  grid-template-rows: auto auto 1fr;
  grid-template-columns: 1fr;
  height: 100%;
`

export function SystemMessagesWidget({
  systemMessages,
  showMarkAsReadMessageButton,
  onClickItem,
  onClickDelete
}: SystemMessagesWidgetProps) {
  const isLg = useCssVariableBreakpoint('--tds-grid-lg')

  const onClickDeleteMessage = (
    e: React.MouseEvent,
    message: SystemMessage
  ) => {
    e.stopPropagation()
    onClickDelete(message.id)
  }

  const onClick = useCallback(
    (message: SystemMessage) => () => {
      onClickItem(message)
    },
    [onClickItem]
  )

  return (
    <div className='tds-mode-variant-secondary tds-u-h-100'>
      <StyledBlock className={cx('tds-u-h-100 tds-u-overflow-scroll')}>
        <ClickableList>
          {systemMessages.map(systemMessage => {
            return (
              <ClickableListItem
                key={systemMessage.id}
                title={systemMessage.title}
                description={getFirstLineFromHtmlText(systemMessage.text)}
                onClick={onClick(systemMessage)}
                rightItem={
                  showMarkAsReadMessageButton && (
                    <RightActionButton
                      id={systemMessage.id.toString()}
                      onClick={event =>
                        onClickDeleteMessage(event, systemMessage)
                      }
                      icon={<TdsIcon name='cross' />}
                    />
                  )
                }
              />
            )
          })}
        </ClickableList>
      </StyledBlock>
    </div>
  )
}
